import { useState, useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { Layout, Menu, Breadcrumb } from "antd";
import { useIdleTimer } from 'react-idle-timer'

import wayabankLogo from "../../assets/images/newlog.svg";
import "./index.css";
import getMenuData from "../../services/menu";

import TopNavDropDown from "./TopNavDropdown";
import PinModal from "../Modal/Pin/PinModal";
import { customBaseUrl, httpGet } from "../../store/http";
import { hideLoader, showLoader } from "../../utils/loader";
import Swal from "sweetalert2";
import { ProfileContext, ProfileContextProvider } from "../../store/context/ProfileContext";
import { clearStorage } from "../../services/helpers";

const { Header, Content, Sider } = Layout;
const { SubMenu } = Menu;

const Index = (props) => {  
  const { children } = props;
  const navigate = useNavigate();
  const [collapsed, setCollapsed] = useState(false);
  const timeout = 1000 * 60 * 5;
  const [remaining, setRemaining] = useState(timeout)
  const [elapsed, setElapsed] = useState(0)
  const [lastActive, setLastActive] = useState(+new Date())
  const [isIdle, setIsIdle] = useState(false)
  const [showTimeOutModal, setShowTimeOutModal] = useState(false)
  const { profile } = useContext(ProfileContext);
  const [otp, setOtp] = useState('')
  const handleOnActive = () => setIsIdle(false)
  const handleOnIdle = () =>{
     setIsIdle(true)
     //setShowTimeOutModal(true)
    // return alert('You are idle for more than 1 minute')
     clearStorage();
     window.location.href = '/';    
     }
    const handleSubmit = async () => {
      if(otp === ''){
        return Swal.fire("Please enter OTP")
      }
      showLoader();
        let res = await httpGet(`${customBaseUrl.authUrl}/api/v1/pin/validate-pin/${otp}`)
        if(res.status){
          setOtp('')
          hideLoader();
            setShowTimeOutModal(false)           
        }else{
          Swal.fire('Oops!', res.message, 'error').then(() => {
          setOtp('')
          clearStorage();
          window.location.href = '/'; 

          })
          hideLoader();

        }

    }

  const {
    getRemainingTime,
    getLastActiveTime,
    getElapsedTime
  } = useIdleTimer({
    timeout,
    onActive: handleOnActive,
    onIdle: handleOnIdle
  })


  useEffect(() => {
    setRemaining(getRemainingTime())
    setLastActive(getLastActiveTime())
    setElapsed(getElapsedTime())

    setInterval(() => {
      setRemaining(getRemainingTime())
      setLastActive(getLastActiveTime())
      setElapsed(getElapsedTime())
    }, 1000)
  }, [])

  const onCollapse = (collapsed) => {
    console.log(collapsed);
    setCollapsed(collapsed);
  };

  const menuData = getMenuData();
  return (
    <ProfileContextProvider>
    <Layout style={{ minHeight: "100vh" }}>
      <Sider
        collapsible
        collapsed={collapsed}
        onCollapse={onCollapse}
        className="waya-glass-sidebar"
        width={270}
      >
        <div
          style={{
            width: "100%",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            padding: "32px 16px",
            borderBottom: '1px solid rgba(0,0,0,0.06)',
            marginBottom: '16px'
          }}
        >
          <img
            src={wayabankLogo}
            alt="wayaLogo"
            style={{
              height: "40px",
              width: collapsed ? "80%" : "auto",
              filter: 'brightness(0)',
              transition: 'all 0.3s ease'
            }}
          />
          {!collapsed && <div style={{ 
            marginTop: '8px', 
            fontSize: '10px', 
            fontWeight: 800, 
            letterSpacing: '2px', 
            color: '#101828',
            opacity: 0.5
          }}>CONTROL PANEL</div>}
        </div>
        <Menu
          theme="light"
          mode="inline"
          defaultSelectedKeys={["1"]}
          style={{ borderRight: 0, background: 'transparent', padding: '0 8px' }}
        >
          {menuData.map((item) => {
            if (item.children) {
              return (
                <SubMenu key={item.key} title={<span style={{ fontWeight: 500 }}>{item.title}</span>} icon={item.icon}>
                  {item.children.map((subItem) => {
                    return (
                      <Menu.Item
                        key={subItem.key}
                        onClick={() => navigate(subItem.url)}
                      >
                        {subItem.title}
                      </Menu.Item>
                    );
                  })}
                </SubMenu>
              );
            }
            return (
              <Menu.Item
                key={item.key}
                onClick={() => navigate(item.url)}
                icon={item.icon}
                style={{ fontWeight: 500 }}
              >
                {item.title}
              </Menu.Item>
            );
          })}
        </Menu>
      </Sider>
      <Layout className="site-layout">
        <Header
          className="site-layout-background"
          style={{
            background: "rgba(255, 255, 255, 0.8)",
            backdropFilter: 'blur(8px)',
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "0 24px",
            height: "64px",
            borderBottom: "1px solid rgba(0,0,0,0.06)"
          }}
        >
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <h2 style={{ 
              margin: 0, 
              fontSize: '18px', 
              fontWeight: 700, 
              color: '#101828',
              textTransform: 'capitalize' 
            }}>
              {window.location.pathname.split('/').pop().replace(/_/g, ' ') || 'Dashboard'}
            </h2>
          </div>
          <TopNavDropDown />
        </Header>
        <Content style={{ margin: "0 16px" }}>
          <div
            className="site-layout-background"
            style={{ padding: 24, minHeight: 360 }}
          >
            {children}
          </div>
        </Content>
       
      {showTimeOutModal &&
      <PinModal
      showModal={showTimeOutModal}
      hideModal = {setShowTimeOutModal}
      otp={otp}
      setOtp={setOtp}
      title="Session has been idle for too long"
      description="Please enter your PIN to continue"
      buttonLabel="Unlock"
      handleSubmit={handleSubmit}
      isIdle={isIdle}
      numInputs={4}
      pinMode={true}
      />
      /*&& (
        
        <div className="modal-container">
          
          <div className="modal-content">
            <div className="modal-header">
              <div className="modal-title">
                <h3>Session Timeout</h3>
                </div>
                <div className="modal-close">
                  <span onClick={() => setShowTimeOutModal(false)}>&times;</span>
                </div>
            </div>
            <div className="modal-body">
              <p>Your session has expired. Please login again.</p>
            </div>
            <div className="modal-footer">
              <button className="btn btn-primary" onClick={() => setShowTimeOutModal(false)}>OK</button>
            </div>
          </div>
        </div>
      )*/}
      </Layout>
      
    </Layout>
    </ProfileContextProvider>
  );
};

export default Index;
